import { IsNotEmpty, IsEnum } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { LeavesDTO } from "./leaves.dto";

export class GetEmpLeaves {
    @ApiProperty()
    @IsNotEmpty()
    year: string;
}